const STORAGE_KEY = 'ucomm.ai-form-prefill';

export type AiFormPrefillTarget = '/todos/new' | '/appointments/new';

export interface AiFormPrefillPayload {
  target: AiFormPrefillTarget;
  fields: Record<string, string | number | boolean | null | undefined>;
  savedAt: number;
}

/** Store AI draft fields for the next form open (avoids long/brittle query strings). */
export function saveAiFormPrefill(
  target: AiFormPrefillTarget,
  fields: Record<string, string | number | boolean | null | undefined>,
): void {
  try {
    const payload: AiFormPrefillPayload = { target, fields, savedAt: Date.now() };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // ignore quota / private mode
  }
}

/** Read AI prefill without removing (safe for React Strict Mode double-mount). */
export function readAiFormPrefill(pathname: string): Record<string, string | number | boolean> | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AiFormPrefillPayload;
    if (!parsed?.target || parsed.target !== pathname) return null;
    if (Date.now() - (parsed.savedAt ?? 0) > 10 * 60 * 1000) return null;
    const fields: Record<string, string | number | boolean> = {};
    for (const [key, value] of Object.entries(parsed.fields ?? {})) {
      if (value !== undefined && value !== null && value !== '') {
        fields[key] = value;
      }
    }
    return Object.keys(fields).length > 0 ? fields : null;
  } catch {
    return null;
  }
}

export function clearAiFormPrefill(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/** @deprecated Prefer router state; kept as sessionStorage fallback. */
export function consumeAiFormPrefill(pathname: string): Record<string, string | number | boolean> | null {
  const fields = readAiFormPrefill(pathname);
  if (fields) clearAiFormPrefill();
  return fields;
}

export const AI_FORM_PREFILL_STATE_KEY = 'aiFormPrefill';

export type AiFormPrefillLocationState = {
  [AI_FORM_PREFILL_STATE_KEY]?: Record<string, string | number | boolean | null | undefined>;
};
